import { render, staticRenderFns } from "./OrderPassangersModal.vue?vue&type=template&id=3277e78c"
import script from "./OrderPassangersModal.vue?vue&type=script&lang=js"
export * from "./OrderPassangersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports